import { useEffect, useState } from "react";
import { CreditCard, Maximize2 } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent } from "@/components/ui/dialog";

/** Authenticated thumbnail of a scanned visiting card, click to enlarge. */
export function CardImage({ scanId, className = "" }) {
  const [url, setUrl] = useState(null);
  const [big, setBig] = useState(false);
  useEffect(() => {
    if (!scanId) return;
    let obj;
    api.get(`/card-scan/${scanId}/image`, { responseType: "blob" })
      .then((r) => { obj = URL.createObjectURL(r.data); setUrl(obj); })
      .catch(() => setUrl(null));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [scanId]);
  if (!scanId) return null;
  return (
    <>
      <button type="button" onClick={() => url && setBig(true)}
        className={`group relative inline-flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 p-1.5 text-xs text-slate-600 hover:bg-slate-100 ${className}`}
        data-testid={`card-image-${scanId}`}>
        {url ? <img src={url} alt="Scanned card" className="h-14 w-auto max-w-[180px] rounded object-cover" /> : <CreditCard className="h-4 w-4 text-slate-400" />}
        <span className="inline-flex items-center gap-1">Scanned card <Maximize2 className="h-3 w-3 opacity-0 group-hover:opacity-100" /></span>
      </button>
      <Dialog open={big} onOpenChange={setBig}>
        <DialogContent className="max-w-3xl p-2" data-testid="card-image-lightbox">
          {url && <img src={url} alt="Scanned card" className="w-full h-auto rounded" />}
        </DialogContent>
      </Dialog>
    </>
  );
}
